import { Button, Stack, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { requestV2 } from "../utils/io";
import StelModal from "./StelModal";

export default function AccountReactivationDialog({ open, onClose, username }) {
  const [loading, setLoading] = useState(false);

  const handleReactivate = async () => {
    setLoading(true);
    try {
      await requestV2(
        "post",
        "/users/reactivation",
        {
          noAuth: true,
          data: { username },
        },
        false
      );

      enqueueSnackbar({
        message: "Verification email sent!",
        variant: "success",
      });
      onClose();
    } catch (err) {
      const errorMessage =
        err.response?.data?.detail ||
        "Failed to send reactivation email. Please try again.";
      enqueueSnackbar({
        message: errorMessage,
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <StelModal
      open={open}
      onClose={onClose}
      title="Your Account Has Been Deactivated"
      width={550}
    >
      <Stack spacing={3}>
        <Typography variant="body1">
          Your account has been deactivated and you can no longer access the
          system.
          <br />
          If you believe this is a mistake or would like to request
          reactivation, please click the button below. A reactivation request
          will be sent to your organization&apos;s owner.
        </Typography>

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="outlined" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleReactivate}
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Reactivation Email"}
          </Button>
        </Stack>
      </Stack>
    </StelModal>
  );
}

AccountReactivationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
};
